import React, { useState } from "react";
import { useMyIdentities, ViewMe } from "@njoy/controller";
import { useNavigate } from "react-router-dom";
import NewButton from "../../components/uiMerge/newButton";
import Template from "../../components/layouts/Template";
import { VerifyNinModal } from "../../components/modals/verifyNinModal";
// import QrCode from "../../assets/images/qrcode.svg";
// import communityLogo from "../../assets/images/nysc-logo.svg";
import IdImage from "../../assets/images/id-image.svg";
import * as ROUTES from "../../constants/routes";
import CardStack from "../../components/cards/CardStack";
import IdCardSkeletonStack from "../../components/cards/IdCardSkeletonStack";
import IdCard from "../shared/NjoyIdCard";
import { QrCode } from "../../components/shared/QrCode";
import moment from "moment";
import PageLoader from "../shared/PageLoader";
// import SurveyModal from "src/components/modals/surveyModal";
// import MerchantInfoModal from "src/components/modals/merchantInfoModal";

export const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { myIdentities, loading } = useMyIdentities({ limit: 5, offset: 0 });
  // const [popUp, setPopUp] = useState(true);

  const [open, setOpen] = useState(false);

  // const [openSurvey, setOpenSurvey] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Template page={1}>
        <ViewMe>
          {(data) => {
            if (!data.match) {
              return <PageLoader />;
            }

            if (loading) {
              return <IdCardSkeletonStack />;
            }

            if (!myIdentities.length) {
              return (
                <>
                  <div className="w-full flex flex-col mt-[32px]">
                    <p className="text-[20px] text-white font-bold  [font-family:'Avenir-Light',Helvetica]">
                      Hi {data.match?.customer?.firstname},
                    </p>
                    <div className="mt-4 flex flex-col gap-1">
                      <p className="text-[18px] text-white font-bold [font-family:'Avenir-Light',Helvetica]">
                        Let's get you verified!
                      </p>
                      <p className="text-md text-[#CECECF] ">
                        Add your{" "}
                        <strong
                          className="text-[white]"
                          style={{ fontWeight: "bolder" }}
                        >
                          ID
                        </strong>{" "}
                        to unlock full access.
                      </p>
                    </div>
                    <div className="id-verify-container w-full flex flex-col items-center justify-center">
                      <img src={IdImage} alt="" />

                      <NewButton
                        fullWidth
                        onClick={() => {
                          if (data.match?.customer?.nin === null) {
                            setOpen(true);
                          } else {
                            navigate(ROUTES.CONNECT_ID);
                          }
                        }}
                        variant="secondary"
                        size="lg"
                        className="w-full mt-10 border border-white"
                      >
                        <p className="text-sm text-center">Connect your ID</p>
                      </NewButton>
                    </div>
                  </div>

                  <VerifyNinModal isOpen={open} onClose={handleClose} />
                </>
              );
            }

            return (
              <div className="px-[1.5rem] min-[450px]:px-[2rem] mx-auto flex justify-center">
                <div className="w-full zoom-large-screen flex flex-col">
                  <CardStack
                  height={500}
                  width={"100%"}
                  selectedStackGap={38}
                  headerHeight={20}
                  topHeight={20}
                  hoverOffset={0}
                  initialCard={-1}>
                    {myIdentities.map((m) => (
                      <IdCard
                        key={m.id || `${m.community?.id || "community"}-${m.idNumber}-${m.validity}`}
                        communityLogo={m.community?.logoUrl  || ''}
                        qrCode={
                          <QrCode
                            value={`${m.community?.alias}: ${m.idNumber.toString()}`}
                            size={42}
                          />
                        }
                        communityName={m.community?.name || ""}
                        name={m.name}
                        validity={moment(m.validity).format("DD-MM-YYYY")}
                        idNumber={m.idNumber}
                        dob={m.dob || ""}
                        gender={
                          m.gender === "m"
                            ? "Male"
                            : m.gender === "f"
                              ? "Female"
                              : m.gender || m.gender
                        }
                        cardColor={m.community?.colorCode || null}
                        idType={m.idType!}
                      />
                    ))}
                  </CardStack>
                </div>

                <VerifyNinModal isOpen={open} onClose={handleClose} />
              </div>
            );
          }}
        </ViewMe>
      </Template>
     
    </>
  );
};
